export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE = 'USER_UPDATE';

export const loginUser = payload => ({ type: USER_LOGIN, payload: payload });
export const logoutUser = payload => ({ type: USER_LOGOUT, payload: payload });
export const updateUser = payload => ({ type: USER_UPDATE, payload: payload });
